import FacebookIcon from 'assets/images/socialMedia/facebookIcon.svg?react';
import InstagramIcon from 'assets/images/socialMedia/instagramIcon.svg?react';
import LinkedinIcon from 'assets/images/socialMedia/linkedinIcon.svg?react';
import TiktokIcon from 'assets/images/socialMedia/tiktokIcon.svg?react';
import TwitterIcon from 'assets/images/socialMedia/xtwitterIcon.svg?react';
import YoutubeIcon from 'assets/images/socialMedia/youtubeIcon.svg?react';
import { APP_URL, EXTERNAL_LINKS, PROMOTION_URL, RESPONSIBLE_GAMING, SOCIAL_MEDIA_LINKS } from 'shared/constants/common';

export const FOOTER_SHORTCUTS = {
	title: 'shortcut',
	links: [
		{ text: 'live', link: APP_URL.live },
		{ text: 'cardGames', link: APP_URL.cardGames },
		{ text: 'BetBuilder', link: PROMOTION_URL.betBuilder },
		{ text: 'cashout', link: PROMOTION_URL.cashout },
		{ text: 'MyBet', link: APP_URL.myBet },
		{ text: 'virtualSports', link: APP_URL.virtualSports },
		{ text: 'eSport', link: APP_URL.eSport },
		{ text: 'sport', link: APP_URL.sport },
		{ text: 'sportBetfanBlog', link: EXTERNAL_LINKS.sportBetfan, isExternal: true },
	],
};

export const FOOTER_INFORMATION = {
	title: 'information',
	links: [
		{ text: 'oNas', link: APP_URL.oNas },
		{ text: 'paymentFooter', link: APP_URL.payment },
		{ text: 'promoCodes', link: APP_URL.kodPromocyjnyBetfan },
		{ text: 'mobileApplication', link: APP_URL.aplikacjaMobilna },
		{ text: 'mapLinkLabel', link: APP_URL.map },
		{ text: 'designationOfStrucutre', link: APP_URL.slownik },
		{ text: 'Oznaczeniadozakładów', link: APP_URL.betMarking },
		{ text: 'useFullLink', link: APP_URL.usefulLinks },
	],
};

export const FOOTER_HELP = {
	title: 'help',
	links: [
		{ text: 'contact', link: APP_URL.contact },
		{ text: 'regulations', link: APP_URL.regulations },
		{ text: 'helpCenter', link: EXTERNAL_LINKS.helpCenter, isExternal: true },
		{ text: 'privacyPolicy', link: APP_URL.privacy },
		{ text: 'generalSettingsPolicy', link: RESPONSIBLE_GAMING, isExternal: true },
		{ text: 'certificateOfWinning', link: APP_URL.certificateOfWinningInfo },
	],
};

export const FOOTER_SOCIAL = {
	title: 'joinUs',
	rows: [
		{
			row: [
				{ icon: FacebookIcon, link: SOCIAL_MEDIA_LINKS.facebook, label: 'Facebook-link' },
				{ icon: InstagramIcon, link: SOCIAL_MEDIA_LINKS.instagram, label: 'Instagram-link' },
				{ icon: TwitterIcon, link: SOCIAL_MEDIA_LINKS.twitter, label: 'Twitter-link' },
			],
		},
		{
			row: [
				{ icon: YoutubeIcon, link: SOCIAL_MEDIA_LINKS.youtube, label: 'Youtube-link' },
				{ icon: LinkedinIcon, link: SOCIAL_MEDIA_LINKS.linkedin, label: 'Linkedin-link' },
				{ icon: TiktokIcon, link: SOCIAL_MEDIA_LINKS.tiktok, label: 'TikTok-link' },
			],
		},
	],
};
